import { EnvironmentProviders, makeEnvironmentProviders  } from "@angular/core";
import { MessageService } from "primeng/api";


export function provideToastConfig() :EnvironmentProviders[] {
    return [
        makeEnvironmentProviders([
            MessageService,
        ])
    ]
}